import { defineNuxtPlugin } from '#app/nuxt'
import { LazyGalleryArrowNextIcon, LazyGalleryArrowPrevIcon, LazyMobileOptionsSheet, LazyCalendar, LazyCheckbox, LazyDropdown, LazyInputMask, LazyInputNumber, LazyInputSwitch, LazyInputText, LazyMultiSelect, LazyPassword, LazyRadioButton, LazyRating, LazyTextarea, LazyButton, LazySplitButton, LazyColumn, LazyDataTable, LazyPaginator, LazyAccordion, LazyAccordionTab, LazyDivider, LazyPanel, LazyScrollPanel, LazyTabView, LazyTabPanel, LazyDialog, LazyOverlayPanel, LazySidebar, LazyMenu, LazyToast, LazyGalleria, LazyBadge, LazySkeleton, LazyProgressSpinner, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["GalleryArrowNextIcon", LazyGalleryArrowNextIcon],
["GalleryArrowPrevIcon", LazyGalleryArrowPrevIcon],
["MobileOptionsSheet", LazyMobileOptionsSheet],
["Calendar", LazyCalendar],
["Checkbox", LazyCheckbox],
["Dropdown", LazyDropdown],
["InputMask", LazyInputMask],
["InputNumber", LazyInputNumber],
["InputSwitch", LazyInputSwitch],
["InputText", LazyInputText],
["MultiSelect", LazyMultiSelect],
["Password", LazyPassword],
["RadioButton", LazyRadioButton],
["Rating", LazyRating],
["Textarea", LazyTextarea],
["Button", LazyButton],
["SplitButton", LazySplitButton],
["Column", LazyColumn],
["DataTable", LazyDataTable],
["Paginator", LazyPaginator],
["Accordion", LazyAccordion],
["AccordionTab", LazyAccordionTab],
["Divider", LazyDivider],
["Panel", LazyPanel],
["ScrollPanel", LazyScrollPanel],
["TabView", LazyTabView],
["TabPanel", LazyTabPanel],
["Dialog", LazyDialog],
["OverlayPanel", LazyOverlayPanel],
["Sidebar", LazySidebar],
["Menu", LazyMenu],
["Toast", LazyToast],
["Galleria", LazyGalleria],
["Badge", LazyBadge],
["Skeleton", LazySkeleton],
["ProgressSpinner", LazyProgressSpinner],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
